import React, { Component } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import Icon from "components/Library/Icon";
import LoadingDots from "components/Library/LoadingDots";
import { FETCH_STATUS } from "config/constants";

import styles from "./NewsletterSubscribeForm.css";
import globalStyles from "styles/global.css";

class NewsletterSubscribeForm extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this._onSubmit.bind(this);
    this.onChange = this._onChange.bind(this);

    this.state = { email: "" };
    this.inputRef = React.createRef();
  }

  componentDidMount() {
    this.setState({
      labelLink: Math.random()
        .toString(36)
        .substring(7),
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.status !== this.props.status &&
      this.props.status === FETCH_STATUS.ERROR
    ) {
      this.inputRef.current.focus();
    }
  }

  _onChange(e) {
    this.setState({ email: e.target.value });
    this.props.reset();
  }

  _onSubmit(e) {
    e.preventDefault();

    this.props.submit({
      email: this.state.email,
      lists: [this.props.list],
      user_vars: {
        source: "axios",
        medium: "referral",
        page: "axios",
        ...this.props.userVars,
      },
    });
  }

  render() {
    const isLoading = this.props.status === FETCH_STATUS.LOADING;
    const hasError = this.props.status === FETCH_STATUS.ERROR;

    return (
      <form
        className={classNames(styles.root, this.props.formClassName)}
        onSubmit={this.onSubmit}
      >
        <span
          className={globalStyles.a11yOnly}
          aria-live="polite"
          role="status"
        >
          {isLoading && "Loading"}
        </span>
        <div className={styles.form}>
          <label
            htmlFor={this.state.labelLink}
            className={globalStyles.a11yOnly}
          >
            Email
          </label>
          <input
            ref={this.inputRef}
            id={this.state.labelLink}
            className={classNames(styles.input, {
              [styles.hasError]: hasError,
            })}
            type="email"
            value={this.state.email}
            placeholder="Type your email"
            disabled={isLoading}
            onChange={this.onChange}
            aria-invalid={hasError}
            required
          />
          <button
            className={classNames(styles.button, {
              [styles.loading]: isLoading,
              [styles.hasError]: hasError,
            })}
            type="submit"
            disabled={isLoading}
            aria-label="Submit your email"
          >
            {isLoading ? (
              <LoadingDots />
            ) : (
              <Icon
                className={classNames(styles.icon, styles.chevron)}
                name="chevron/right"
                description=""
              />
            )}
          </button>
        </div>
        <div aria-live="assertive" role="alert">
          {hasError && (
            <label htmlFor={this.state.labelLink} className={styles.errorText}>
              {this.props.error.message ||
                (Array.isArray(this.props.error) && this.props.error[0]) ||
                this.props.error}
            </label>
          )}
        </div>
      </form>
    );
  }
}

export default NewsletterSubscribeForm;

NewsletterSubscribeForm.propTypes = {
  status: PropTypes.oneOf(Object.values(FETCH_STATUS)).isRequired,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.instanceOf(Error),
    PropTypes.arrayOf(PropTypes.string),
  ]),
  list: PropTypes.string,
  userVars: PropTypes.shape({
    source: PropTypes.string,
    medium: PropTypes.string,
    campaign: PropTypes.string,
    term: PropTypes.string,
    content: PropTypes.string,
    page: PropTypes.string,
  }),
  formClassName: PropTypes.string,
};
